import * as React from 'react';

const FirstNotificationStartPointWidget= ({props})=> {

    return <div></div>
}

export default FirstNotificationStartPointWidget;